import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import SmileScanWeb from '@brands/Dashboard/SmileScan/Patient/SmileScanWeb';
import usePricings from '@brands/hooks/usePricings';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { CaseType } from '@brands/services/cases/types/ICase';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';
import { isMobile } from 'react-device-detect';

const ImageCaptureValidation: React.FC = () => {
  const user: AuthState = useAppSelector(selectAuth);
  const isWebPatient = user.userInfo?.role.name === UserRoleName.Patient && !isMobile;
  const { pricings, loading } = usePricings(isWebPatient);
  const smileScanOffered = pricings.some((price) => price.case_types[0] === CaseType.smile_scan);

  const getComponent = (): JSX.Element => {
    if (isWebPatient && loading) {
      return <Loading fullScreen />;
    }
    if (isWebPatient && smileScanOffered) {
      return <SmileScanWeb />;
    }
    return <NotFoundPage />;
  };

  return <div>{getComponent()}</div>;
};

export default ImageCaptureValidation;
